<script lang="ts">
  import { timelineGroups, selectedEventId, timelineEvents } from '../stores/debugger-timeline';
  import { animate, stagger } from 'motion';
  import { onMount } from 'svelte';
  import TimelineEvent from './TimelineEvent.svelte';

  let collapsedGroups = $state<Set<string>>(new Set());
  let eventsContainerEl: HTMLDivElement | undefined = $state();

  let eventCount = $derived(($timelineEvents).length);

  $effect(() => {
    const groups = $timelineGroups;
    if (groups.length > 0 && eventsContainerEl) {
      const items = eventsContainerEl.querySelectorAll('[data-timeline-event]');
      if (items.length > 0) {
        animate(Array.from(items), { opacity: [0, 1], y: [12, 0] }, { duration: 0.3, delay: stagger(0.05) });
      }
    }
  });

  function toggleGroup(date: string) {
    const next = new Set(collapsedGroups);
    if (next.has(date)) next.delete(date);
    else next.add(date);
    collapsedGroups = next;
  }

  function selectEvent(id: string) {
    selectedEventId.set(id);
  }
</script>

<div class="flex flex-col h-full bg-bg-panel">
  <!-- Header -->
  <div class="px-4 py-3 border-b border-border flex items-center justify-between shrink-0">
    <h2 class="text-sm font-semibold text-text-primary">Timeline</h2>
    {#if eventCount > 0}
      <span class="text-[10px] font-medium px-2 py-0.5 rounded-full bg-accent/20 text-accent">
        {eventCount}
      </span>
    {/if}
  </div>

  <!-- Event List -->
  <div class="flex-1 overflow-y-auto">
    {#if ($timelineGroups).length === 0}
      <div class="flex flex-col items-center justify-center h-full px-6 text-center animate-fade-in-up">
        <div class="w-12 h-12 rounded-full bg-bg-card flex items-center justify-center mb-3">
          <svg class="w-6 h-6 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <p class="text-xs text-text-muted leading-relaxed">Search for an advertiser to see timeline</p>
      </div>
    {:else}
      <div bind:this={eventsContainerEl}>
      {#each $timelineGroups as group}
        <button
          onclick={() => toggleGroup(group.date)}
          class="w-full flex items-center justify-between px-4 py-2 bg-bg-dark/50 border-b border-border-light text-left hover:bg-bg-hover transition-colors"
        >
          <span class="text-[11px] font-medium text-text-secondary">{group.date}</span>
          <div class="flex items-center gap-2">
            <span class="text-[10px] text-text-muted">{group.events.length}</span>
            <svg
              class="w-3 h-3 text-text-muted transition-transform duration-200 {collapsedGroups.has(group.date) ? '-rotate-90' : ''}"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </button>

        {#if !collapsedGroups.has(group.date)}
          <div class="divide-y divide-border-light">
            {#each group.events as event (event.id)}
              <div data-timeline-event>
                <TimelineEvent
                  {event}
                  selected={$selectedEventId === event.id}
                  onselect={selectEvent}
                />
              </div>
            {/each}
          </div>
        {/if}
      {/each}
      </div>
    {/if}
  </div>
</div>
